import { getLocationParamer } from "@/utils/common";
export const LoadScripts = (scriptUrls, callback) => {
	if (!scriptUrls || scriptUrls.length === 0) {
	  console.warn('No script URLs provided');
	  return;
	}
  
	// Remove duplicates and invalid URLs
	const urls = [...new Set(scriptUrls.filter(url => url && typeof url === 'string'))];
  
	if (urls.length === 0) {
	  console.warn('No valid script URLs found');
	  return;
	}
  
	const loadScript = (url, onSuccess, onError) => {
	  const script = document.createElement('script');
	  script.src = url;
	  script.async = true;
	  
	  let hasFired = false; // Prevent double firing of onload/onerror
	  script.onload = () => {
		if (hasFired) {
		  return;
		}
		hasFired = true;
		onSuccess();
	  };
	  script.onerror = () => {
		if (hasFired) {
		  return;
		}
		hasFired = true;
		console.warn(`Failed to load script: ${url}`);
		onError();
	  };
	  document.head.appendChild(script);
	};
  
	let index = 0;
	const loadedUrls = new Set(); // Track loaded URLs to prevent duplicates
  
	const loadNext = () => {
	  if (index >= urls.length) {
		callback();
		return;
	  }
  
	  const currentUrl = urls[index];
	  if (loadedUrls.has(currentUrl)) {
		console.warn(`Skipping duplicate URL: ${currentUrl}`);
		index++;
		loadNext();
		return;
	  }
  
	  loadScript(
		currentUrl,
		() => {
		  loadedUrls.add(currentUrl);
		  index++;
		  loadNext();
		},
		() => {
		  loadedUrls.add(currentUrl); // Mark as attempted even if failed
		  index++;
		  loadNext();
		}
	  );
	};
  
	loadNext();
  };

export const GBGdpr = {
	_isEU: false, // default value is false
	mainDomain: ".hkjc.com",
	countryListUrl: window.globalConfig.VITE_ADOBE_EU,
	cookieRetention: 1440, // isEU cookie retention (in minute)
    isEU: function () {	
		var isEUCookie = this.getIsEUCookie();  
		if (isEUCookie === ""){
			this.checkIsEU();
		}else {
			this._isEU = (isEUCookie === "false") ? false : true ;
		}
        return this._isEU;		
	},
	getIsEUCookie: function () {
		var name = "isEU" + "=";
		var decodedCookie = unescape(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	setIsEUCookie: function (cvalue) {
		var cdomain = window.location.hostname.substr(this.mainDomain.length * -1) === this.mainDomain ? this.mainDomain : window.location.hostname;
		var now = new Date();
		var minutes = this.cookieRetention;
		now.setTime(now.getTime() + (minutes * 60 * 1000));
		var expires = "; expires=" + now.toGMTString();
		document.cookie = "isEU=" + cvalue + expires + "; path=/; domain=" + cdomain;
	},
	checkIsEU: function () { // to check where customer is in EU and put the result to cookie
		try {
			// read eu.js to array
			var arrayCountryList = new Array();
			var request = new XMLHttpRequest();
			request.open("GET", this.countryListUrl, false);
			request.setRequestHeader('Accept', 'application/json');
			request.onreadystatechange = function () {
				if (this.readyState === 4) {
					var objJSON = JSON.parse(this.responseText);
					for (i in objJSON.countryCode) {
						arrayCountryList.push(objJSON.countryCode[i]);
					}
				}
			}
			request.send();

			var CountryCode = "";
			var request2 = new XMLHttpRequest();
			request2.open('GET', 'https://api.ipdata.co?api-key=ac5f659c94717be9e87ee36deff50b57f29b1f12dff205e7c4fbbfd8', false);
			request2.setRequestHeader('Accept', 'application/json');
			request2.onreadystatechange = function () {
				if (this.readyState === 4) {
					var objJSON = JSON.parse(this.responseText);
					CountryCode = objJSON.country_code;
				}
			}
			request2.send();
			
			this._isEU = (arrayCountryList.indexOf(CountryCode) < 0) ? false : true;
			this.setIsEUCookie(this._isEU.toString());
		} catch (e) {
			this._isEU = false;
			this.setIsEUCookie(this._isEU.toString());
		}
	}
}

export const TrackPageView = (lang)=> {
    try {
		console.log("TrackPageView");

		var pageId = "wcip";
		if(window.location.pathname.toLocaleLowerCase().includes("/member")) {
			pageId = "wcip-Member";
			const s = getLocationParamer("step");
			if(s>0){
				return ;
			}
		}

		window.WCIPCookie.reset();
		const attemptTrack = (retries = 5, interval = 1000) => {
			if (window.adobeDataLayer) {
				const isEU = window.WAGdpr.isEU()
				const cuno = window.WCIPCookie?.getCuno() == null? "": window.WCIPCookie?.getCuno(); 
				const customerSegment = window.WCIPCookie?.getCustomerSegment() == null? "": window.WCIPCookie.getCustomerSegment();

				if(!isEU) {
					if (!adobeDataLayer.some(event => event.event === "pageview")) {
						adobeDataLayer.push({
							"event": "watracking",
							"IsEU": isEU
						});
						adobeDataLayer.push({
							"event": "pageview",
							"page": {
								"id": pageId,
								"language": lang === "en-us"?"en":lang,
							},
							"user": {
								"cuno": cuno,
								"customer_segment": customerSegment
							}
						});
						//Change report suite (eVar35) to Membership App if detected
						if (window.MBSSClient) {
							adobeDataLayer.push({
								"report_suite": "Membership App"
							});
						}
					}
				}
			} else if (retries > 0) {
				console.warn('adobeDataLayer not defined, retrying...' + retries);
				setTimeout(() => attemptTrack(retries - 1, interval), interval);
			  } else {
				console.error('adobeDataLayer not available after retries');
			  }
		}
		attemptTrack();
    } catch (e) {
        console.error("adobleLaunch", e);
    }
}

export const TrackClickEvent = (eventName, lang) => {
	try {
		console.log("TrackClickEvent", eventName);

		var pageId = "wcip";
		if(window.location.pathname.toLocaleLowerCase().includes("/member")) {
			pageId = "wcip-Member";
		}
		let interactionEvent_obj = {
			event: "interaction",
			page: {
				id: pageId,
				language: lang === "en-us"?"en":lang,
			} ,
			interaction: {
				eventID: eventName
			}
		}
		if(window.location.pathname.toLocaleLowerCase().includes("/change/member") && sessionStorage.getItem('customerHash')) {
			interactionEvent_obj.user = {
				"cuno": sessionStorage.getItem('customerHash')
			}
		}
		if(window.adobeDataLayer) {
			window.adobeDataLayer.push(interactionEvent_obj)
		}
	}
	catch (e) {
		console.error("adobleLaunch", e);
	}
} 